var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
// ARTICLE_CATEGORIES
var ARTICLE_CATEGORIES = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query ArticleCategories {\n    article_categories {\n      id\n      name\n      created_at\n      updated_at\n    }\n  }\n"], ["\n  query ArticleCategories {\n    article_categories {\n      id\n      name\n      created_at\n      updated_at\n    }\n  }\n"])));
export var useArticleCategoriesQuery = function (options) {
    return useQuery(ARTICLE_CATEGORIES, options);
};
export default ARTICLE_CATEGORIES;
var templateObject_1;
